import { render } from "./FooterToolBar.vue?vue&type=template&id=eb6c9074"
import script from "./FooterToolBar.vue?vue&type=script&lang=js"
export * from "./FooterToolBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__